module.exports = __webpack_public_path__ + "static/media/2.862f3920.jpg";